import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { initialDriverForm } from '../../Data/Constants'
import { addDriver } from '../../firebase-services/db-services'
import { getDriversFetch } from '../../Redux/slices/driverState'
import handleChange from '../../Utils/HandleChange'
import { FormInput, FormRow } from '../Controls/Input'
import {  toast } from 'react-toastify';

export default function AddDriver() {
  const dispatch = useDispatch()
    const [form, setForm] = useState(initialDriverForm)
    const changeHandler = handleChange(form, setForm)
    const submitHandler = (e) => {
        e.preventDefault()
        addDriver(form).then(res=>{
            dispatch(getDriversFetch())
            toast.success("Driver Added Successfully")
            //ScrollToTargetAdjusted('transactionTable')
          }).catch(e=>{
            toast.error("Failed to add New Driver")
            console.log(e)
          })
        
    }
  return (
    <div id='addDriverForm' className="bg-gray-100 p-8 rounded-md mx-auto my-36 w-full max-w-7xl">
    <form className='w-full'>
      <h1 className='text-2xl sm:text-3xl md:text-4xl font-bold tracking-wide mb-7'>Add New Driver</h1>
      <FormRow mx={3}>
        <FormInput name='name' type="text" label='Driver Name' onChange={changeHandler} placeholder={"Party Name"} />
        <FormInput name='mobile' type='text' label='Mobile No.' placeholder='9756721202' onChange={changeHandler} />
      </FormRow>
      <FormRow mx={3}>
        <FormInput name='address' label='Address' onChange={changeHandler} placeholder="Driver's Address" />
      </FormRow>

      <div className='flex flex-row gap-4 mx-4'>
        <button
          className="hover:bg-[#4f48ee] rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
          onClick={submitHandler}
        >
          Submit
        </button>
        <input type="reset"
          className="hover:bg-gray-600 cursor-pointer rounded-md bg-gray-500 py-3 px-8 text-center text-base font-semibold text-white outline-none"
        />
      </div>
    </form>
  </div>
  )
}
